import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-other-layout',
  templateUrl: './other-layout.component.html',
  styleUrls: ['./other-layout.component.scss']
})
export class OtherLayoutComponent implements OnInit {

  constructor() {
  }

  ngOnInit(): void {
  }

}
